export const environment = {
  production: false,
  apiUrl: 'https://passking-development-ephtcfcwaqfphehq.eastus-01.azurewebsites.net/api'
};
